import { BElement, BaseComponent } from "utils/base-component"
import "./tab.scss"

type Config = {
  onChange: (key: string) => void
}

export class Tabs extends BaseComponent<Config> {
  static cssClass = "tabs"
  private tabs!: BElement[]
  private activeTab?: BElement
  private slider!: BElement

  init() {
    this.tabs = this.elements("tab")
    this.slider = this.element("slider")!

    this.tabs.forEach((tab) => {
      if (tab.hasModifier("active")) this.activeTab = tab

      tab.element.addEventListener("click", (event) => {
        event.preventDefault()
        this.activeTab = tab
        this.tabs.forEach((t) => t.toggleModifier("active", t === tab))
        this.refresh()
        this.config.onChange(tab.element.dataset.key!)
      })
    })

    this.refresh()
    window.addEventListener("resize", () => this.refresh())

    // Update slider position when container scrolls
    this.root.addEventListener(
      "scroll",
      () => {
        this.updateSliderPosition()
      },
      { passive: true },
    )
  }

  get activeKey() {
    return this.activeTab ? this.activeTab.element.dataset.key! : undefined
  }

  setActiveTab(key: string) {
    const tab = this.tabs.find((t) => t.element.dataset.key === key)
    if (!tab) return

    this.activeTab = tab
    this.tabs.forEach((t) => t.toggleModifier("active", t === tab))
    this.refresh()
    this.config.onChange(key)
  }

  refresh() {
    if (!this.activeTab) return

    this.updateSliderPosition()

    setTimeout(() => {
      this.updateSliderPosition()
    }, 300)
  }

  private updateSliderPosition() {
    if (!this.activeTab) return

    const tab = this.activeTab.element

    const tabLeft = tab.offsetLeft
    const tabWidth = tab.offsetWidth

    this.slider.element.style.left = `${tabLeft}px`
    this.slider.element.style.width = `${tabWidth}px`
  }
}
